;(function($) {


    // Hamburger
    $('.js-hamburger a').each(function () {
        $(this).click(function (e) {
            e.preventDefault();
            $('html').toggleClass('nav-open')
        })
    })


}(jQuery));
